export interface PermissionStatus {
  name: string;
  code: PermissionStatusCode;
  disabled: boolean;
}

export enum PermissionStatusCode {
  ACTIVATEDBYMUNICIPALITY,
  ACTIVATEDALL,
  TEASERBYMUNICIPALITY,
  TEASERALL,
  DEACTIVATEDBYMUNICIPALITY,
  DEACTIVATEDALL,
}
